<template>
    <BreadCrumb PageTitle="Liste des zones tarifaire" />
    <ListeTariffZone/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeTariffZone from "@/components/ZoneTarifaire/ListeTariffZone.vue";
  
    export default defineComponent({
      name: "ListeTariffZonePage",
      components: {
        BreadCrumb,
        ListeTariffZone,
      },
    });
  </script>